module.exports = __webpack_public_path__ + "img/members of the yakumo family.a5b97169.png";